export function rules(formData) {
    return {
        'status': [
            { required: true, message: '请选择状态', trigger: ['blur', 'change'] },
        ],
        'name': [
            { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
            { max: 20, message: '活动名称最多20个字', trigger: 'blur' },
        ],
        'schedule': [
            { required: true, message: '请选择档期', type: 'array', min: 1, trigger: ['change', 'blur'] },
        ],
        'clueBoothList': [
            { required: true, message: '请选择点位', type: 'array', min: 1, trigger: ['change', 'blur'] },
            {
                validator: function (rule, value, callback) {
                    if (!formData.schedule || !formData.schedule.length) {
                        callback(new Error('请先选择日期'));
                    }
                    else {
                        callback();
                    }
                },
            },
        ],
    };
}
